import React from 'react';

function SectionHeader({ tag, title, titleAccent, description, align = 'center' }) {
  const alignClass = align === 'left' ? 'text-left' : 'text-center';

  return (
    <div className={`mb-14 md:mb-16 ${alignClass}`}>
      {tag && (
        <span className="mb-4 inline-block text-xs font-bold uppercase tracking-[0.14em] text-accent">
          {tag}
        </span>
      )}
      <h2 className="text-3xl font-black leading-tight tracking-tight text-white md:text-4xl lg:text-5xl">
        {title}
        {titleAccent && (
          <>
            <br />
            <span className="text-primary">{titleAccent}</span>
          </>
        )}
      </h2>
      {description && (
        <p className={`mt-4 max-w-2xl text-base leading-relaxed text-silver md:text-lg ${align === 'center' ? 'mx-auto' : ''}`}>
          {description}
        </p>
      )}
    </div>
  );
}

export default SectionHeader;
